export const shiftsNumber = [1, 2, 3] as const
